import { Icon } from "@circle-react-shared/Icon";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { legacyClassNames } from "@/react/helpers/cssAnchorHelpers";

export interface LoaderProps {
  condition?: boolean;
}

export const Loader = ({ condition }: LoaderProps) => {
  if (!condition) return null;

  return (
    <div
      className={classNames(
        legacyClassNames("quickpost__loader-wrapper"),
        "flex justify-center p-4",
      )}
    >
      <Icon type="loader" />
    </div>
  );
};
